import React from "react";
import { CiHeart } from "react-icons/ci";

const BlogContent = ({ data }) => {
  
  return (
    <div className="">
      <div className="desc_details overflow-x-scroll" dangerouslySetInnerHTML={{ __html: data }} />
      <div className="flex justify-between py-4 mt-3 border-b border-[#8E9192]">
        <span className="flex items-start gap-3">
          <span className="flex gap-2">
            <img src="/Star.png" className="w-[22px]" alt="start" />
            <img src="/Star.png" className="w-[22px]" alt="start" />
            <img src="/Star.png" className="w-[22px]" alt="start" />
            <img src="/Star.png" className="w-[22px]" alt="start" />
            <img src="/Star.png" className="w-[22px]" alt="start" />
          </span>
          <p>0/5</p>
        </span>
        <span className="flex gap-2">
          <img src="/share.png" className="w-[22px]" alt="start" />
          
          <CiHeart size={24} />
        </span>
      </div>
    </div>
  );
};

export default BlogContent;
